import { useEffect, useRef, useState } from 'react';
import { v4 as uuid } from 'uuid';

import { BannerSeverity } from '@rover/kibble/patterns/Banner/BannerSeverity.constants';

import { ToastHandle } from '.';

export type ToastMessageProps = {
  message: string;
  severity?: `${BannerSeverity}`;
};

export type ToastProps = {
  isToastVisible: boolean;
  showToast: (toastMessage: ToastMessageProps) => void;
  dismissToast: () => void;
  toastProperties?: {
    ref: React.RefObject<ToastHandle>;
    onClose: () => void;
    children: React.ReactNode;
    severity?: `${BannerSeverity}`;
  };
  toastKey: string;
};

const useToast = (): ToastProps => {
  const toastRef = useRef<ToastHandle>(null);
  const [toastMessage, setToastMessage] = useState<ToastMessageProps>({
    message: '',
    severity: BannerSeverity.INFO,
  });
  const [componentKey, setComponentKey] = useState(uuid());

  useEffect(() => {
    if (toastMessage.message) {
      setComponentKey(uuid());
    }
  }, [toastMessage.message]);

  return {
    toastProperties: {
      ref: toastRef,
      onClose: () => setToastMessage({ message: '', severity: BannerSeverity.INFO }),
      children: toastMessage.message,
      severity: toastMessage.severity,
    },
    toastKey: componentKey,
    isToastVisible: !!toastMessage.message,
    showToast: setToastMessage,
    dismissToast: () => {
      if (toastRef.current) {
        toastRef.current.dismiss();
      }
    },
  };
};

export default useToast;
